<template>
    <section class="p-3" id="newPharmacyForm">
        <section class="form-group">
            <h6><b>Pharmacy Information</b></h6>
            <div class="d-grid px-4 py-2">
                <div class="d-flex flex-column">
                    <div class="d-grid mb-2">
                        <label for="New_Pharmacy_Name">Pharmacy Name: <span class="text-danger">*</span></label>
                        <input
                            type="text"
                            class="form-control"
                            id="New_Pharmacy_Name"
                            :maxlength="50"
                            v-model="newPharmacy.Name"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Pharmacy_Line1">Address Line 1: </label>
                        <input
                            class="form-control"
                            id="New_Pharmacy_Line1"
                            v-model="newPharmacy.AddressLine1"
                            type="text"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="Pharmacy_Line2">Address Line 2:</label>
                        <input
                            class="form-control"
                            id="Pharmacy_Line2"
                            :maxlength="50"
                            v-model="newPharmacy.AddressLine2"
                            type="text"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="Pharmacy_City">City:</label>
                        <input
                            class="form-control"
                            id="Pharmacy_City"
                            :maxlength="11"
                            name="PharmacyCity"
                            v-model="newPharmacy.AddressCity"
                            type="text"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="Pharmacy_AddressStateZip">State</label>
                        <div class="d-flex">
                            <select class="form-select" v-model="newPharmacy.AddressStateCode">
                                <option selected value="">Select State</option>
                                <option
                                    v-for="(addState, index) of addressStateCode"
                                    :value="addState.value"
                                    :key="index"
                                >
                                    {{ addState.text }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="Pharmacy_AddressZip">Zip</label>
                        <div class="d-flex">
                            <input
                                class="form-control"
                                id="Pharmacy_AddressZip"
                                :maxlength="13"
                                name="AddressZipCode"
                                type="text"
                                v-number-only
                                v-model="newPharmacy.AddressZipCode"
                            />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="d-grid mb-2">
                        <label for="referral-mobile-number"> Primary Phone: <span class="text-danger">*</span></label>
                        <input
                            type="text"
                            class="form-control phone-number-input"
                            :value="formatPhone(phone)"
                            :maxlength="14"
                            placeholder="Enter Number"
                            @input="(event:any) => setPhoneHome(event.target.value)"
                            v-number-only
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="Contact_First_Name">Contact First Name:</label>
                        <input
                            class="form-control"
                            id="Contact_First_Name"
                            :maxlength="10"
                            v-model="newPharmacy.ContactPersonFirstName"
                            type="text"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="Contact_Last_Name">Contact Last Name:</label>
                        <input
                            class="form-control"
                            id="Contact_Last_Name"
                            :maxlength="10"
                            v-model="newPharmacy.ContactPersonLastName"
                            type="text"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Email">Email:</label>
                        <input
                            class="form-control"
                            id="New_Email"
                            :maxlength="100"
                            name="EmailAddress"
                            v-model="newPharmacy.EmailAddress"
                            type="text"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="referral-mobile-number"> Fax Number: </label>
                        <input
                            type="text"
                            class="form-control phone-number-input"
                            :value="formatPhone(fax)"
                            maxlength="14"
                            placeholder="Enter Number"
                            @input="(event:any) => setFaxNumber(event.target.value)"
                            v-number-only
                        />
                    </div>
                </div>
            </div>
            <div class="pb-2">
                <label class="w-100 ms-2" id="New_Comment" for="New_Comment">Comment:</label>
                <textarea
                    class="form-control mx-4 w-95 text-area"
                    id="New_Comment"
                    name="New_Comment"
                    v-model="newPharmacy.Comment"
                ></textarea>
            </div>
        </section>
        <div class="d-flex justify-content-center">
            <button class="btn btn-primary me-2 border-0" @click="addNewPharmacy()">Save</button>
            <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
        </div>
    </section>
</template>

<style src="./AddPharmacy.scss"></style>

<script lang="ts" src="./AddPharmacy.ts"></script>
